module.exports = __webpack_public_path__ + "media/img/video-610ad701c0597b9bfa7f614192e0a826.webp";